import React, { useEffect, useRef, useState } from "react";
import ModalAdvertisement from "./ModalAdvertisement";
import { setCookieComponent } from "../utils/cookie";
import { useDispatch } from "react-redux";
import { setReduxClosePopupAdvertisement } from "../Redux/futures/home/actions";
import { getMyanmarTime } from "../helper/helper";

// Tracks which ad position was last shown and on which date.
// Position index cycles forward each new calendar day, wrapping back to 0.
const KEY_ADV_DATE  = 'pm_adv_date';
const KEY_ADV_INDEX = 'pm_adv_index';
// Quảng cáo đã hiện trong ngày: `${ngày}|${adKey}`. Hạn mức "1 lần/ngày" của pu6
// tính theo TỪNG quảng cáo — CMS đổi/thêm quảng cáo trong ngày thì quảng cáo mới
// vẫn hiện được ở lần reload sau.
const KEY_ADV_SEEN  = 'pm_adv_seen';

// Ngày nghiệp vụ theo giờ Myanmar (UTC+6:30) — phải trùng mốc với todayDateStr()
// trong utils/popupManager.js, nếu không index vị trí và hạn mức "1 lần/ngày" sẽ
// đổi ngày ở 2 thời điểm khác nhau. Trước đây dùng toISOString() (UTC).
function todayStr() {
  return getMyanmarTime().format('YYYY-MM-DD');
}

// API chưa chắc có id — fallback sang ảnh để vẫn phân biệt được 2 quảng cáo.
function adKey(ad) {
  return String(ad?.id ?? ad?.image ?? '');
}

// Hàm THUẦN (không ghi localStorage): isEligible của engine gọi nhiều lần mỗi
// lượt nên chỉ được đọc. Việc ghi nằm ở recordAdShown(), gọi khi popup hiện thật.
// Trả về { ad, index } của quảng cáo hôm nay, hoặc null khi list rỗng.
export function pickTodayAd(list) {
  if (!Array.isArray(list) || list.length === 0) return null;

  const lastDate = localStorage.getItem(KEY_ADV_DATE);
  // Giá trị hỏng trong localStorage cho ra NaN; (NaN + 1) % len vẫn là NaN nên
  // index sẽ khoá cứng ở 0 vĩnh viễn và không xoay vòng nữa. Chuẩn hoá về -1.
  const parsedIndex = parseInt(localStorage.getItem(KEY_ADV_INDEX) ?? '-1', 10);
  const lastIndex = Number.isInteger(parsedIndex) ? parsedIndex : -1;

  // Advance position on a new day; stay on the same position within the day.
  const index = lastDate === todayStr()
    ? Math.min(Math.max(0, lastIndex), list.length - 1) // same day — keep current index
    : (lastIndex + 1) % list.length;                    // new day — advance and wrap

  // bounds-safe fallback (vd index âm do localStorage bị sửa tay)
  return list[index] ? { ad: list[index], index } : { ad: list[0], index: 0 };
}

export function isAdSeenToday(ad) {
  return localStorage.getItem(KEY_ADV_SEEN) === `${todayStr()}|${adKey(ad)}`;
}

function recordAdShown({ ad, index }) {
  const today = todayStr();
  localStorage.setItem(KEY_ADV_DATE,  today);
  localStorage.setItem(KEY_ADV_INDEX, String(index));
  localStorage.setItem(KEY_ADV_SEEN,  `${today}|${adKey(ad)}`);
}

// Data do engine fetch sẵn (DATA_SOURCES.advertisement trong popupRegistry.jsx)
// ở mỗi page load; component chỉ hiển thị quảng cáo của hôm nay đã được chọn.
export default function ComponentModalAdvertisement({ pick, onClose }) {
  const [openPopupAdver, setOpenPopupAdver] = useState(true);
  const timeoutRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!pick?.ad) return;
    recordAdShown(pick);
    dispatch(setReduxClosePopupAdvertisement(true));
    setCookieComponent({
      name: "show-popup-advertisement",
      value: true,
      maxAge: 300, // 5 min — used by other parts of the app
    });
    localStorage.setItem("show-popup-advertisement", true);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleCancel = () => {
    setOpenPopupAdver(false);
    onClose?.();
    timeoutRef.current = setTimeout(() => {
      dispatch(setReduxClosePopupAdvertisement(false));
    }, 1000 * 60 * 5); // 5 min
  };

  if (!openPopupAdver || !pick?.ad) return <></>;

  return (
    <ModalAdvertisement
      dataAdvertisement={pick.ad}
      open={openPopupAdver}
      onCancel={handleCancel}
    />
  );
}
